import navigationHtml from '../../public/navigation.html';

document.getElementById('top-container').innerHTML = navigationHtml;
